import { createContext } from 'react';
import { defaultAbility } from './constants';

export const AbilityContext = createContext(defaultAbility);
